import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../../content/siteContent";
import { SectionHeading } from "./primitives";

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <section id="faqs" data-testid="faq-section" className="bg-white py-24 lg:py-32 border-t border-hair">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="container-page grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow="Questions">Program questions, answered.</SectionHeading>
        </div>
        <div className="lg:col-span-8">
          <div className="border-t border-hair">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q} className="border-b border-hair">
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left focus-ring rounded-sm"
                  >
                    <span className="font-display font-semibold text-navy text-base lg:text-lg tracking-tight">
                      {f.q}
                    </span>
                    {isOpen ? (
                      <Minus className="h-5 w-5 text-teal shrink-0" />
                    ) : (
                      <Plus className="h-5 w-5 text-slate-ink shrink-0" />
                    )}
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 text-slate-ink text-sm lg:text-[15px] leading-relaxed max-w-2xl">
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
